var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssessmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3571_3164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 28.3333V20H20.8333C21.2917 20 21.6667 20.375 21.6667 20.8333V26.0617L23.3333 24.395V20.8333C23.3333 19.455 22.2117 18.3333 20.8333 18.3333H15V10.8333C15 9.455 13.8783 8.33333 12.5 8.33333H7.5C6.12167 8.33333 5 9.455 5 10.8333V30H17.7283L19.395 28.3333H15ZM13.3333 28.3333H6.66667V10.8333C6.66667 10.375 7.04167 10 7.5 10H12.5C12.9583 10 13.3333 10.375 13.3333 10.8333V28.3333ZM1.66667 4.16667C1.66667 2.78833 2.78833 1.66667 4.16667 1.66667H20V13.3333H31.6667V16.27C32.1917 15.92 32.7533 15.6617 33.3333 15.4567V12.155L21.1783 0H4.16667C1.86833 0 0 1.86833 0 4.16667V40H15V38.3333H1.66667V4.16667ZM21.6667 2.845L30.4883 11.6667H21.6667V2.845ZM8.33333 13.3333H11.6667V15H8.33333V13.3333ZM8.33333 18.3333H11.6667V20H8.33333V18.3333ZM8.33333 23.3333H11.6667V25H8.33333V23.3333ZM16.6667 25V23.3333H20V25H16.6667ZM38.78 19.5533C37.155 17.9283 34.5117 17.9283 32.8883 19.5533L18.335 34.1067V39.9983H24.2267L38.78 25.445C40.405 23.82 40.405 21.1767 38.78 19.5533ZM37.6017 24.2667L23.5367 38.3317H20.0017V34.7967L34.0667 20.7317C35.04 19.7583 36.6283 19.7583 37.6017 20.7317C38.575 21.705 38.5767 23.2917 37.6017 24.2667Z",
    fill: "#0073FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3571_3164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/assessment-icon.2c91738189ebcaee5a6e20befc1c9ecc.svg";
export { ForwardRef as ReactComponent };